export default __webpack_public_path__ + "static/media/AboutSupportShell.37bf15d7.svg";